export const getApiBase = () => {
    const apiUrl = process.env.REACT_APP_API_URL as string | undefined;
    if (!apiUrl) {
        // Fail fast - g�r det tydeligt i dev hvis env mangler
        throw new Error("REACT_APP_API_URL is not set");
    }
    return apiUrl;
};

export const safeJson = async <T = any>(res: Response): Promise<T | null> => {
    try {
        return (await res.json()) as T;
    } catch {
        return null;
    }
};

export const unwrapArray = (data: any): any[] => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    return [];
};